import {environment} from '@/commons/configs/Config';
import Cookies from "js-cookie";

const baseRequestUrl = environment.apiUrlTwo + "/files";

export async function getFilesUUIDS(path) {
    let token = Cookies.get(environment.tokenName);
    const requestUrl = `${baseRequestUrl}/getFilesFromPath`;

    try {
        const response = await fetch(requestUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                authorization: token
            },
            body: path
        });

        if (!response.ok) {
            return null;
        }

        // Estrai l'URL pubblico del file dalla risposta
        return await response.json();

    } catch (error) {
        console.error("Errore durante la chiamata all'API:", error);
        return null;
    }
}


export async function getFileInfo(uuid) {
    const requestUrl = `${baseRequestUrl}/getFileInfos/` + uuid;

    try {
        const response = await fetch(requestUrl, {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + Cookies.get(environment.tokenName)
            },
        });

        if (!response.ok) {
            return null;
        }

        // Estrai l'URL pubblico del file dalla risposta
        return await response.json();

    } catch (error) {
        console.error("Errore durante la chiamata all'API:", error);
        return null;
    }
}